import { forwardRef, useImperativeHandle, useRef } from 'react';
import TkiQrcode from './tkiqrcode';

export interface QrImgProps {
  cid?: string;
  val?: string;
  size?: number;
  iconsize?: number;
  unit?: 'upx' | 'px';
  show?: boolean;
  background?: string;
  foreground?: string;
  pdground?: string;
  icon?: string;
  lv?: number;
  onval?: boolean;
  loadMake?: boolean;
  usingComponents?: boolean;
  showLoading?: boolean;
  loadingText?: string;
  onResult?: (url: string) => void;
}

export interface QrImgRef {
  makeCode: (val: string) => void;
  clearCode: () => void;
  saveCode: () => void;
}

const QrImg = forwardRef<QrImgRef, QrImgProps>((props, ref) => {
  const {
    val = '',
    size = 200,
    icon = '',
    iconsize = 40,
    unit = 'upx',
    background = '#000000',
    foreground = '#ffffff',
    lv = 3,
    onval = false,
    loadMake = true,
    onResult,
  } = props;

  // 子组件ref
  const qrcodeRef = useRef<any>(null);

  // 暴露给外部调用
  useImperativeHandle(ref, () => ({
    makeCode: (v: string) => {
      qrcodeRef.current?._makeCode(v);
    },
    clearCode: () => {
      qrcodeRef.current?._clearCode();
    },
    saveCode: () => {
      qrcodeRef.current?._saveCode();
    },
  }));

  return (
    <div className="qrimg">
      <TkiQrcode
        ref={qrcodeRef}
        val={val}
        size={size}
        unit={unit}
        background={background}
        foreground={foreground}
        icon={icon}
        iconSize={iconsize}
        lv={lv}
        onval={onval}
        loadMake={loadMake}
        onResult={onResult}
      />
    </div>
  );
});

export default QrImg;
